// extracted by mini-css-extract-plugin
export default {"label_style":"antdInput_label_style__4nMjV","input":"antdInput_input__8CQi-"};